import type { SupplierI } from '../pages/TenderViewPage/types';

export const annualPriceFromPriceInformation = (
    pi?: { price?: number; priceBasis?: string; basis?: string } | null
): number | null => {
    if (pi == null || pi.price == null) return null;
    const price = Number(pi.price);
    if (Number.isNaN(price)) return null;
    const raw = String(pi.priceBasis ?? pi.basis ?? '').toLowerCase();
    if (raw === 'month' || raw === 'per_month') return price * 12;
    return price;
};

export const annualPriceForSupplier = (item: SupplierI): number | null => {
    const fromPi = annualPriceFromPriceInformation(item?.payload?.price_information);
    if (fromPi != null) return fromPi;
    const raw = item?.payload?.price;
    if (raw == null || raw === '') return null;
    const n = Number(raw);
    return Number.isNaN(n) ? null : n;
};

/** Whole rands without decimals; show cents only when non-zero (after half-up rounding to 2 places). */
export const formatSupplierPriceZAR = (amount: number): string => {
    const scaled = Math.round(amount * 100);
    const display = scaled / 100;
    const cents = Math.abs(scaled % 100);
    if (cents === 0) {
        return `R${display.toLocaleString('en-ZA', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    }
    return `R${display.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
